import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["removeFlag", "preview", "trashButton"];
  static values = { placeholder: String };

  remove() {
    this.removeFlagTarget.value = '1';
    this.previewTarget.style.backgroundImage = `url("${this.placeholderValue}")`;
    this.trashButtonTarget.classList.add('hidden');
  }
}
